import 'managers/ResizeManager';
import 'managers/ScrollManager';
import Carousel from 'components/Carousel';
import Header from 'components/Header';
import ProjectSticky from 'components/ProjectSticky';
import { mqMobile } from 'core/MediaQueries';
import Player from 'components/Player';
import Reveal from 'components/Reveal';

class AppManager {
  constructor() {
    this.bind();

    window.addEventListener('DOMContentLoaded', this.initialize);
  }

  bind() {
    this.initialize = this.initialize.bind(this);
    this.handleScrollTo = this.handleScrollTo.bind(this);
    this.handleMobileChange = this.handleMobileChange.bind(this);
  }

  initialize() {
    this.ui = {
      $scrollTo: [...document.querySelectorAll('.scroll-to')],
    };

    this.mobileMql = window.matchMedia(mqMobile);
    this.handleMobileChange();

    this.events();
    this.initializeCarousels();

    // Core modules
    const $headers = [...document.querySelectorAll('.header')];
    const $players = [...document.querySelectorAll('.player')];
    const $projectStickies = [...document.querySelectorAll('.project__sticky')];
    const $reveals = [...document.querySelectorAll('.reveal')];

    $headers.forEach(($element) => new Header({ $element }));
    $players.forEach(($element) => new Player({ $element }));
    $projectStickies.forEach(($element) => new ProjectSticky({ $element }));
    $reveals.forEach(($element) => new Reveal({ $element }));
  }

  initializeCarousels() {
    const $defaults = [...document.querySelectorAll('.carousel--project')];
    const $projects = [...document.querySelectorAll('.carousel--projects')];

    $defaults.forEach(($element) => new Carousel({ $element }));

    $projects.forEach(
      ($element) =>
        new Carousel({
          $element,
          autoLayout: false,
          groupBy: 2,
          breakpoints: [mqMobile],
          onBreakpointChange(mqls, context) {
            const { $wrapper, $items, length } = context;

            mqls.forEach((mql) => {
              if (mql.media === mqMobile && mql.matches) {
                context.groupBy = 1;
                $wrapper.style.width = `${length * 100}%`;
              } else {
                context.groupBy = 2;
                $wrapper.style.width = `${(length / 2) * 100}%`;
              }

              $items.forEach(($item) => ($item.style.width = `${100 / length}%`));
            });
          },
        })
    );
  }

  events() {
    this.ui.$scrollTo.forEach(($item) => $item.addEventListener('click', this.handleScrollTo));
    this.mobileMql.addListener(this.handleMobileChange);
  }

  handleScrollTo(event) {
    event.preventDefault();
    // const isMiddle = event.currentTarget.classList.contains('scroll-to--middle');

    document.querySelector(event.currentTarget.getAttribute('href')).scrollIntoView({
      block: 'start',
      behavior: 'smooth',
      // inline: isMiddle ? 'center' : 'start',
    });
  }

  handleMobileChange() {
    const isMobile = this.mobileMql.matches;
    const $carousels = [...document.querySelectorAll('.carousel--mobile')];

    if (isMobile) {
      this.mobileCarousels = $carousels.map(($element) => new Carousel({ $element }));
    } else if (this.mobileCarousels) {
      console.log(this.mobileCarousels);
      this.mobileCarousels.forEach((carousel) => carousel.destroy());
      delete this.mobileCarousels;
    }
  }
}

export default new AppManager();
